<template>
  <b-row class="overflow-auto mt-2">
    <b-col>
      <div class="flex-column align-items-start">
        <div class="d-flex w-100">
          <!--Inst icons in separate component -->
          <inst-icons :instAT="feature.asset_type"></inst-icons>
          <strong
            style="font-size: 0.8rem;
            vertical-align: middle"
          >{{ feature.instrument_name }}</strong>
        </div>
        <div>
          <b-badge
            id="discontinued-badge"
            v-if="feature.discontinued"
            pill
            variant="secondary"
          >Discontinued</b-badge>
        </div>
        <div>
          <span title="Reference Designator">
            <i class="fas fa-hashtag"></i>
          </span>
          {{feature.reference_designator}}
          <br />
          <span title="Status">
            <!--Status indicator icon using nereus information-->
            <i class="material-icons icon-color-dark">
              {{getStatusIndicatorIcon(feature.reference_designator)}}
            </i>
          </span>
          <!--Status indicator text using nereus information-->
          <span class="status-title">
            {{getStatusIndicatorText(feature.reference_designator)}}
          </span>
          <br />
          <span title="Description">
            <i class="fas fa-align-right"></i>
          </span>
          {{feature.description}}
          <br />
          <span title="Model">
            <i class="fas fa-qrcode"></i>
          </span>
          {{feature.model ? feature.model : "N/A"}}
          <br />
          <span title="Manufacturer">
            <i class="fas fa-industry"></i>
          </span>
          {{feature.manufacturer ? feature.manufacturer : "N/A"}}
          <br />
          <span title="Owner">
            <i class="fas fa-user"></i>
          </span>
          {{feature.owner ? feature.owner : "N/A"}}
        </div>
        <div class="mt-2 mb-2">
          <b-button-group>
            <b-button
              variant="outline-info"
              size="sm"
              v-on:click="showDetails
              (feature.reference_designator)">
              Details
            </b-button>
            <!-- <b-button
              :disabled="!feature.harvest_flag"
              v-b-tooltip.hover
              :title="feature.harvest_flag ?
                        'Cloud data available.' :
                        'No cloud data available.'"
              variant="outline-info"
              size="sm"
              @click="showModal(`${feature.reference_designator}`,
                      feature.instrument_name)"
            >Availability</b-button>-->
            <b-button
              :disabled="btnDisabled(`${feature.instrument_url}`)"
              variant="outline-info"
              size="sm"
              :href="getInstURL(`${feature.instrument_url}`)"
              target="_blank"
            >
              Learn More
              <i class="fas fa-external-link-alt fa-sm"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { iconNames } from '../../utils/constants';
import InstIconsVue from './instIcons';

export default {
  props: ['feature'],
  data() {
    return {
      modalShow: false,
      ooiURL: `${process.env.OOIURL}`,
      iconNames,
    };
  },
  components: {
    'inst-icons': InstIconsVue,
  },
  computed: {
    ...mapState({
      instruments: (state) => state.instruments,
      statusIndicators: (state) => state.statusIndicators,
    }),
  },
  methods: {
    ...mapActions([
      'mapSelectInst',
      'toggleSidebar',
      'determineSidebarContent',
    ]),
    /**
     * Passes in the instrument's reference designator. This information is used to find
     * the specific object from whole instruments listing. This method saves that
     * object and saves which sidebar data to display and opens the sidebar.
     * @param {*} refDes - instrument reference designator
     */
    showDetails(refDes) {
      const selectedFeature = _.find(this.instruments, [
        'reference_designator',
        refDes,
      ]);
      this.mapSelectInst({ instrument: selectedFeature });
      this.determineSidebarContent({ sidebarContent: 'inst-details' });
      this.toggleSidebar({ showSidebar: true });
    },
    /**
     * Helper method to filter through the statusIndicator information
     * @param {string} refDes - instrument reference designator
     */
    getStatusHelper(refDes) {
      let statusValue = _.get(this.statusIndicators, refDes);
      if (_.isEmpty(statusValue)) {
        statusValue = 'unset';
      }
      return statusValue.toLowerCase();
    },
    /**
     * Takes the status information and displays "Status" text
     * @param {string} refDes - instrument reference designator
     */
    getStatusIndicatorText(refDes) {
      const statusHolderText = this.getStatusHelper(refDes);
      const newStr = statusHolderText.replace(/-|_/g, ' ');
      let text;
      if (_.isEmpty(statusHolderText)) {
        text = 'No status available';
      } else {
        text = newStr[0].toUpperCase() + newStr.substring(1);
      }
      return text;
    },
    /**
     * Takes the status information and displays the "Status icon"
     * @param {string} refDes - instrument reference designator
     */
    getStatusIndicatorIcon(refDes) {
      const statusHolder = this.getStatusHelper(refDes);
      return this.iconNames[statusHolder];
    },
    /**
     * Checks what type of URL and instrumen has (external or within IO)
     * @param {string} instURL - instrument URL
     */
    getInstURL(instURL) {
      if (_.startsWith(instURL, 'http')) {
        return instURL;
      }
      return this.ooiURL + instURL;
    },
    /**
     * If there is no URL available, disable the 'Learn More' btn
     * @param {string} instURL - instrument URL
     */
    btnDisabled(instURL) {
      if (_.isEmpty(instURL)) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
.icon-color-dark {
  color: black !important;
  font-size: 1rem !important;
  margin-left: -0.15rem !important;
  margin-top: 0.15rem !important;
  position: fixed !important;
}
.status-title {
  margin-left: 1rem;
}
</style>
